export { VpInfoMenu } from './VpInfoMenu';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpInfoMenu/index.js